import { CameraIcon, FolderIcon, PaperclipIcon } from "lucide-react";
import {
  FileTrigger as FileTriggerPrimitive,
  type FileTriggerProps as FileTriggerPrimitiveProps,
} from "react-aria-components";

import { Button, type ButtonProps } from "@/components/ui/button";

interface FileTriggerProps extends FileTriggerPrimitiveProps {
  withIcon?: boolean;
  isDisabled?: boolean;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
}

export function FileTrigger({
  variant = "outline",
  size = "default",
  withIcon = true,
  ...props
}: FileTriggerProps) {
  return (
    <FileTriggerPrimitive {...props}>
      <Button isDisabled={props.isDisabled} variant={variant} size={size}>
        {withIcon &&
          (props.defaultCamera ? (
            <CameraIcon data-slot="icon" />
          ) : props.acceptDirectory ? (
            <FolderIcon data-slot="icon" />
          ) : (
            <PaperclipIcon data-slot="icon" className="rotate-45" />
          ))}
        {props.children ? (
          props.children
        ) : (
          <>
            {props.allowsMultiple
              ? "Browse a files"
              : props.acceptDirectory
                ? "Browse"
                : "Browse a file"}
            ...
          </>
        )}
      </Button>
    </FileTriggerPrimitive>
  );
}
